import React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Button, Grid } from "@mui/material";
// import FileUploadIcon from "@mui/icons-material/FileUpload";
// import CloseIcon from "@mui/icons-material/Close";
// import { useNavigate } from "react-router-dom";
// import UploadIcon from "@mui/icons-material/Upload";
// import Zoom from "react-medium-image-zoom";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
// import StarIcon from "@mui/icons-material/Star";
// import StarBorderIcon from "@mui/icons-material/StarBorder";
import AddIcon from "@mui/icons-material/Add";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CheckIcon from "@mui/icons-material/Check";

import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";

import swal from "sweetalert";
import { makeGetRequest, makePostRequest } from "../../../utils/utils";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import EditMaintenanceModal from "./EditMaintenanceModal";
// import AddBankModal from "./ActiveBankModal";
import ActiveBankModal from "./ActiveBankModal";

import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import dayjs from "dayjs";
import moment from "moment";

// import ServiceProViderAddModal from "./ServiceProViderAddModal";
// import AddVehicleModal from "./AddVehicleModal";
// End

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function InvoiceSettingsTab() {
  // const navigate = useNavigate();

  // For Append
  const { useState } = React;

  const [showLoader, setShowLoader] = React.useState(false);

  const [value, setValue] = React.useState(0);
  const [maintenence_type, setMaintenence_type] = React.useState("");
  const [amount, setAmount] = React.useState(0);
  const [isActive, setIsActive] = React.useState();

  const [maintenenceList, setMaintenenceList] = React.useState([]);

  const [account_holder, setAccount_holder] = React.useState("");
  const [account_type, setAccount_type] = React.useState("");
  const [account_no, setAccount_no] = React.useState(0);
  const [bank_name, setBankName] = React.useState("");
  const [ifsc_code, setIfscCode] = React.useState("");
  const [upi_id, setUpiId] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [micr_code, setMicr_code] = React.useState("");
  const [isBankActive, setIsBankActive] = React.useState(false);
  const [invoiceType, setInvoiceType] = React.useState();
  const [bankDetailsList, setBankDetailsList] = React.useState([]);

  const [tax_name, setTaxName] = React.useState("");
  const [tax_amount, setTaxAmount] = React.useState(0);
  const [isTaxActive, setIsTaxActive] = React.useState();
  const [taxList, setTaxList] = React.useState([]);
  const [taxErrMsg, setTaxErrMsg] = React.useState("");

  const [notes, setNotes] = React.useState("");
  const [notesList, setNotesList] = React.useState([]);
  const [isNotesActive, setIsNotesActive] = React.useState();

  const [editMaintenenceFlag, setEditMaintenenceFlag] = React.useState(false);
  const [editNotesFlag, setEditNotesFlag] = React.useState(false);
  const [editTaxFlag, setEditTaxFlag] = React.useState(false);
  const [editBankDetailsFlag, setEditBankDetailsFlag] = React.useState(false);

  const [activeMonthlyBank, setActiveMonthlyBank] = useState(0);
  const [activeMiscellaneousBank, setActiveMiscellaneousBank] = useState(0);

  // for create schedule invoice
  const [ownersList, setOwnersList] = React.useState([]);
  const [selectedApart, setselectedApart] = useState([]);
  const [selectedResident, setselectedResident] = useState([]);

  const [selectedApartmentIds, setSelectedApartmentIds] = useState([]);
  const [selectedResidentIds, setSelectedResidentIds] = useState([]);
  const [selectedOption, setselectedOption] = useState("");

  const [invoice_date] = React.useState(dayjs(new Date()));
  const [due_date] = React.useState(invoice_date.add(15, "day"));
  const [subject, setSubject] = React.useState();

  const [, setMaintenenceJsonList] = React.useState([]);

  const [taxJsonList, SetTaxJsonList] = React.useState([]);

  const [, setSubTotal] = React.useState(0);
  const [advanceReceived, setAdvanceReceived] = React.useState(0);

  const [, setPastDue] = React.useState(0);
  const [, setLateFee] = React.useState(0);

  const [, setTotalPayable] = React.useState(0);
  const [, setTaxTotal] = React.useState(0);
  const [maintenenceTotal, setMaintenenceTotal] = React.useState(0);
  const [, setHiddenTotalPayable] = React.useState(0);

  const [flagbtndisable, setflagbtndisable] = useState(false);
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [getLateFee, setgetLateFee] = useState(0);
  const [schedulerId, setschedulerId] = useState();
  const [currentDate] = React.useState(dayjs(new Date()));
  const [enddate, setenddate] = React.useState(
    dayjs(new Date())
  );
  const [dtforupdate, setdtforupdate] = useState(dayjs(new Date()));

  // let mainteneceJson;
  let taxJson;
  //Validations For Maintenence
  const Validation_Schema = Yup.object().shape({
    maintenence_type: Yup.string()
      .trim("White spaces not allow")
      .strict(true)
      .required("Required")
      .matches(
        /^([a-z.A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
        "Numbers/Special Characters Not Allowed!!"
      ),
    amount: Yup.number()
      .min(0, "Invalid Amount ")
      // .max(, "Invalid Amount")
      .required("Required"),
  });

  // var formikInitials = {
  //   maintenence_type: "",
  //   amount: 0,
  // };
  if (editMaintenenceFlag) {
    var formikInitials = {
      maintenence_type: maintenence_type,
      amount: amount,
    };
  } else {
     formikInitials = {
      maintenence_type: "",
      amount: 0,
    };
  }
  //Validations For Notes
  const Validation_Schema_Notes = Yup.object().shape({
    notes: Yup.string().required("Required"),
    // .matches(
    //   /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
    //   "Numbers not allowed!!"
    // ),
  });

  // var formikInitials_notes = {
  //   notes: "",
  // };
  // change by gautami for edit err msg
  if (editNotesFlag) {
    var formikInitials_notes = {
      notes: notes,
    };
  } else {
     formikInitials_notes = {
      notes: "",
    };
  }

  //Validations For Tax
  const Validation_Schema_Tax = Yup.object().shape({
    tax_name: Yup.string()
      .required("Required")
      .matches(
        /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
        "Numbers not allowed!!"
      ),
    tax_amount: Yup.string()
      .matches(/^\d+$/, "The field should have digits only")
      .max(2, "Invalid Amount ")
      .required("Required"),
  });

  var formikInitials_tax = {
    tax_name: "",
    tax_amount: 0,
  };

  const [editTaxJson, setEditTaxJson] = React.useState(null);

  //Validations For Tax
  const Validation_Schema_BankDetails = Yup.object().shape({
    account_holder: Yup.string()
      .required("Required")
      .matches(
        /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
        "Numbers not allowed!!"
      ),
    account_type: Yup.string()
      .required("Required")
      .matches(
        /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
        "Numbers not allowed!!"
      ),
    bank_name: Yup.string()
      .required("Required")
      .matches(
        /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
        "Numbers not allowed!!"
      ),
    upi_id: Yup.string().required("Required"),
    ifsc_code: Yup.string().required("Required"),
    micr_code: Yup.string(),
    account_no: Yup.string()
      .matches(/^\d+$/, "The field should have digits only")
      .max(12, "Account no should have max 12 Digits.. ")
      .required("Required"),
    address: Yup.string().required("Required"),
  });

  // var formikInitials_BankDetails = {
  //   account_holder: "",
  //   account_type: "",
  //   account_no: 0,
  //   bank_name: "",
  //   ifsc_code: "",
  //   address: "",
  //   upi_id: "",
  //   micr_code: "",
  // };

  // change by gautami for edit err msg
  if (editBankDetailsFlag) {
    var formikInitials_BankDetails = {
      account_holder: account_holder,
      account_type: account_type,
      account_no: 0,
      bank_name: bank_name,
      ifsc_code: ifsc_code,
      address: address,
      upi_id: upi_id,
      micr_code: micr_code,
      invoiceType: invoiceType,
    };
  } else {
     formikInitials_BankDetails = {
      account_holder: "",
      account_type: "",
      account_no: 0,
      bank_name: "",
      ifsc_code: "",
      address: "",
      upi_id: "",
      micr_code: "",
      invoiceType: "",
    };
  }

  async function MaintenenceListing() {
    let bodyFormData = {};
    setShowLoader(true);
    await makeGetRequest("maintenence/getall", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          console.log("Maintenence Data");
          console.log(response.data.data);
          // setlength(response.data.data.rowCount);
          const data = response.data.data;
          setMaintenenceList(data);
          // let sum = response.data.data.filter((o) => o.is_active === true)
          //   .map((o) => o.amount)
          //   .reduce((a, c) => {
          //     return a + c;
          //   });
          //   console.log("sum",sum)
          // setMaintenenceTotal(sum);

          if (data.length > 0) {
            let sum = data
              .filter((o) => o.is_active === true)
              .map((o) => o.amount)
              .reduce((a, c) => a + c, 0); // Using 0 as the initial value for reduce
            console.log("sum", sum);
            setMaintenenceTotal(sum);
          } else {
            // If data is empty, set the total to 0
            setMaintenenceTotal(0);
          }
        }
        setShowLoader(false);
      })
      .catch((err) => {
        console.log("first err msg")
        console.error(err);
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function editMaintenence(maintenenceId) {
    setEditMaintenenceFlag(true);

    let bodyFormData = {};
    setShowLoader(true);
    await makeGetRequest("maintenence/getbyid/" + maintenenceId, bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          const data = response.data.data;
          setMaintenence_type(response.data.data.maintenence_type);
          setAmount(response.data.data.amount);
          setIsActive(response.data.data.is_active);
          localStorage.setItem("editMaintenenceId", maintenenceId);

          var formikInitials = {
            maintenence_type: maintenence_type,
            amount: amount,
          };
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function saveMaintenence() {
    if (maintenence_type && amount) {
      setShowLoader(true);
      // let inputdata = {
      //   maintenence_type: maintenence_type,
      //   amount: amount,
      //   is_active: isActive,
      // };
      if (editMaintenenceFlag) {
        let inputdata = {
          maintenence_type: maintenence_type,
          amount: amount,
          is_active: isActive,
        };
        inputdata.maintenence_id = localStorage.getItem("editMaintenenceId");
        await makePostRequest("maintenence/update", inputdata)
          .then((response) => {
            if (response.data.data !== undefined) {
              swal("Success", "Maintenence Updated successfully", "success", {
                timer: 1000,
                buttons: false,
              });
              MaintenenceListing();
              setMaintenence_type("");
              setAmount("");
              setEditMaintenenceFlag(false);
              localStorage.removeItem("editMaintenenceId");
            }
            setShowLoader(false);
          })
          .catch((err) => {
            setShowLoader(false);
            swal("There was an error!", "more error details", "warning");
          });
      } else {
        setShowLoader(true);
        let inputdata = {
          maintenence_type: maintenence_type,
          amount: amount,
          is_active: true,
        };
        await makePostRequest("maintenence/insert", inputdata)
          .then((response) => {
            if (response.data.data !== undefined) {
              swal("Success", "Maintenence added successfully", "success", {
                timer: 1000,
                buttons: false,
              });
              MaintenenceListing();
              setMaintenence_type("");
              setAmount("");
            }
            setShowLoader(false);
          })
          .catch((err) => {
            setShowLoader(false);
            swal("There was an error!", "more error details", "warning");
          });
      }
    }
  }

  async function deleteMaintenence(maintenenceId) {
    const willDelete = await swal({
      title: "Are you sure?",
      text: "Do you really want to delete these records? This process cannot be undone.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (willDelete) {
      let bodyFormData = {};
      setShowLoader(true);
      await makeGetRequest("maintenence/delete/" + maintenenceId, bodyFormData)
        .then((response) => {
          if (response.status == "201") {
            swal("Success", "Record deleted successfully", "success", {
              timer: 1000,
              buttons: false,
            });
            MaintenenceListing();
          }
          setShowLoader(false);
        })
        .catch((err) => {
          setShowLoader(false);
          swal("There was an error!", "more error details", "warning");
        });
    }
  }

  const [isMaintenenceChecked, setIsMaintenenceChecked] = React.useState(true);

  async function maintenenceChecked(obj) {
    var maintenenceObj = obj;
    // console.log(obj.amount);
    if (maintenenceObj.is_active) setIsMaintenenceChecked(false);
    else setIsMaintenenceChecked(true);

    setShowLoader(true);

    let inputdata = {
      maintenence_id: maintenenceObj.maintenence_id,
      maintenence_type: maintenenceObj.maintenence_type,
      is_active: isMaintenenceChecked,
      amount: maintenenceObj.amount,
    };
    await makePostRequest("maintenence/update", inputdata)
      .then((response) => {
        if (response.data.data !== undefined) {
          // swal("Success", "Maintenence added successfully", "success", {
          //   timer: 1000,
          //   buttons: false,
          // });
          MaintenenceListing();
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function handleCancelMaintenance() {
    setEditMaintenenceFlag(false);
    setMaintenence_type("");
    setAmount(0);
    setIsActive(false);
    localStorage.removeItem("editMaintenenceId");
  }

  async function BankDetailsListing() {
    let bodyFormData = {};

    await makeGetRequest("bankdetails/getall", bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          console.log("Bank details Data");
          console.log(response.data.data);
          // setlength(response.data.data.rowCount);
          const data = response.data.data;
          setBankDetailsList(data);

          const filteredRecords = data.filter(
            (record) =>
              record.is_active === true &&
              record.invoice_type === "Monthly Maintenance"
          );

          setActiveMonthlyBank(filteredRecords.length);

          console.log("mm", filteredRecords);

          const filteredmisch = data.filter(
            (record) =>
              record.is_active === true &&
              record.invoice_type === "Miscellaneous"
          );
          setActiveMiscellaneousBank(filteredmisch.length);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function editBankDetails(bankDetailsId) {
    setEditBankDetailsFlag(true);

    let bodyFormData = {};

    await makeGetRequest("bankdetails/getbyid/" + bankDetailsId, bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          console.log("Bank details");
          console.log(response.data.data);
          // setlength(response.data.data.rowCount);
          const data = response.data.data;
          setAccount_holder(response.data.data.account_holder);
          setAccount_type(response.data.data.account_type);
          setAccount_no(response.data.data.account_no);
          setBankName(response.data.data.bank_name);
          setIfscCode(response.data.data.ifsc_code);
          setUpiId(response.data.data.upi_id);
          setMicr_code(response.data.data.micr_code);
          setAddress(response.data.data.address);
          setIsBankActive(response.data.data.is_active);
          setInvoiceType(response.data.data.invoice_type);
          localStorage.setItem("editBankDetailsId", bankDetailsId);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function handleCancelBankDetails() {
    setEditBankDetailsFlag(false);
    setAccount_holder("");
    setAccount_type("");
    setAccount_no("");
    setBankName("");
    setIfscCode("");
    setUpiId("");
    setMicr_code("");
    setAddress("");
    setIsBankActive("");
    localStorage.removeItem("editBankDetailsId");
  }

  async function handleChangeCheckBox(e, primaryAccType) {
    console.log(e.target.checked);
    // setIsBankActive(e.target.checked);
    setInvoiceType(primaryAccType);
    console.log(primaryAccType);
  }

  async function saveBankDetails() {
    if (
      account_holder == "" ||
      account_type == "" ||
      account_no == "" ||
      bank_name == "" ||
      ifsc_code == "" ||
      upi_id == "" ||
      address == ""
    ) {
      swal("Please fill all the Details!", "", "warning");
    } else {
      // var inputdata = {
      //   account_holder: account_holder,
      //   account_type: account_type,
      //   account_no: account_no,
      //   bank_name: bank_name,
      //   ifsc_code: ifsc_code,
      //   upi_id: upi_id,
      //   address: address,
      //   micr_code: micr_code,
      //   invoice_type: invoiceType,
      //   is_active: isBankActive,
      // };
      if (editBankDetailsFlag) {
        var inputdata = {
          account_holder: account_holder,
          account_type: account_type,
          account_no: account_no,
          bank_name: bank_name,
          ifsc_code: ifsc_code,
          upi_id: upi_id,
          address: address,
          micr_code: micr_code,
          invoice_type: invoiceType,
          is_active: isBankActive,
        };
        inputdata.bank_details_id = localStorage.getItem("editBankDetailsId");
        await makePostRequest("bankdetails/update", inputdata)
          .then((response) => {
            if (response.data.data !== undefined) {
              swal("Success", "Bank Details updated successfully", "success", {
                timer: 1000,
                buttons: false,
              });

              setAccount_holder("");
              setAccount_type("");
              setAccount_no(0);
              setBankName("");
              setIfscCode("");
              setUpiId("");
              setAddress("");
              setMicr_code("");
              setInvoiceType();
              // formikInitials_BankDetails = {
              //   account_holder: "",
              //   account_type: "",
              //   account_no: 0,
              //   bank_name: "",
              //   ifsc_code: "",
              //   address: "",
              //   upi_id: "",
              // };
              BankDetailsListing();
              setEditBankDetailsFlag(false);
              localStorage.removeItem("editBankDetailsId");
            }
          })
          .catch((err) => {
            swal("There was an error!", "more error details", "warning");
          });
      } else {
        var inputdata = {
          account_holder: account_holder,
          account_type: account_type,
          account_no: account_no,
          bank_name: bank_name,
          ifsc_code: ifsc_code,
          upi_id: upi_id,
          address: address,
          micr_code: micr_code,
          invoice_type: invoiceType,
          is_active: true,
        };
        await makePostRequest("bankdetails/insert", inputdata)
          .then((response) => {
            if (response.data.data !== undefined) {
              swal("Success", "Bank Details added successfully", "success", {
                timer: 1000,
                buttons: false,
              });

              setAccount_holder("");
              setAccount_type("");
              setAccount_no(0);
              setBankName("");
              setIfscCode("");
              setUpiId("");
              setAddress("");
              setInvoiceType();

              // formikInitials_BankDetails = {
              //   account_holder: "",
              //   account_type: "",
              //   account_no: 0,
              //   bank_name: "",
              //   ifsc_code: "",
              //   upi_id: "",
              //   address: "",
              // };
              BankDetailsListing();
            }
          })
          .catch((err) => {
            swal("There was an error!", "more error details", "warning");
          });
      }
    }
  }

  async function deleteBankDetails(bankDetailsId) {
    const willDelete = await swal({
      title: "Are you sure?",
      text: "Do you really want to delete these records? This process cannot be undone.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (willDelete) {
      let bodyFormData = {};

      await makeGetRequest("bankdetails/delete/" + bankDetailsId, bodyFormData)
        .then((response) => {
          if (response.status == "201") {
            swal("Success", "Record deleted successfully", "success", {
              timer: 1000,
              buttons: false,
            });
            BankDetailsListing();
          } else {
            swal("There was an error!", response.message, "warning");
          }
        })
        .catch((err) => {
          swal("There was an error!", "more error details", "warning");
        });
    }
  }

  async function bankDetailsChecked(obj) {
    var bankDetailsObj = obj;
    if (bankDetailsObj.is_active) {
      if (activeMonthlyBank === 1 || activeMiscellaneousBank === 1) {
        swal("Warning", "You can not deactivate this record", "warning");
        return;
      }
      setIsBankActive(false);
      bankDetailsObj.is_active = false;
    } else {
      setIsBankActive(true);
      bankDetailsObj.is_active = true;
    }

    await makePostRequest("bankdetails/statusupdate", bankDetailsObj)
      .then((response) => {
        if (response.data.data !== undefined) {
          // swal("Success", "Maintenence added successfully", "success", {
          //   timer: 1000,
          //   buttons: false,
          // });
          BankDetailsListing();
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function editTax(taxId) {
    setEditTaxFlag(true);

    let bodyFormData = {};

    await makeGetRequest("tax/getbyid/" + taxId, bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          console.log("Tax details");
          console.log(response.data.data);
          setTaxName(response.data.data.tax_name);
          setTaxAmount(response.data.data.tax_amount);
          setIsTaxActive(response.data.data.is_active);
          setEditTaxJson(response.data.data);
          localStorage.setItem("editTaxId", taxId);

          if (response.data.data.tax_name == "Late Fee") {
            document.getElementById("tax_name").disabled = true;
            document.getElementById("tax_name").setAttribute("readonly", true);
            setTaxErrMsg("Unable to change this tax name");
          }
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function handleCancelTax() {
    setEditTaxFlag(false);
    setTaxName("");
    setTaxAmount(0);
    setIsTaxActive(false);
    setTaxErrMsg("");
    localStorage.removeItem("editTaxId");
  }

  async function saveTax() {
    // alert("In Fun")
    if (tax_name || tax_amount) {
      // alert("In If " , tax_name)
      let inputdata = {
        tax_name: tax_name,
        tax_amount: tax_amount,
      };

      if (editTaxFlag) {
        inputdata.is_active = isTaxActive;
        inputdata.tax_id = localStorage.getItem("editTaxId");
        await makePostRequest("tax/update", inputdata)
          .then((response) => {
            if (response.data.data !== undefined) {
              setTaxAmount(0);
              setTaxName("");

              swal("Success", "Tax updated successfully", "success", {
                timer: 1000,
                buttons: false,
              });
              setEditTaxFlag(false);
              TaxListing();
              localStorage.removeItem("editTaxId");
            }
          })
          .catch((err) => {
            swal("There was an error!", "more error details", "warning");
          });
      } else {
        inputdata.is_active = true;
        await makePostRequest("tax/insert", inputdata)
          .then((response) => {
            if (response.data.data !== undefined) {
              setTaxAmount(0);
              setTaxName("");

              swal("Success", "Tax added successfully", "success", {
                timer: 1000,
                buttons: false,
              });

              TaxListing();
            }
          })
          .catch((err) => {
            swal("There was an error!", "more error details", "warning");
          });
      }
    }
    setTaxErrMsg("");
  }

  async function deleteTax(taxId) {
    const willDelete = await swal({
      title: "Are you sure?",
      text: "Do you really want to delete these records? This process cannot be undone.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (willDelete) {
      let bodyFormData = {};

      await makeGetRequest("tax/delete/" + taxId, bodyFormData)
        .then((response) => {
          if (response.status == "201") {
            swal("Success", "Record deleted successfully", "success", {
              timer: 1000,
              buttons: false,
            });
            TaxListing();
          } else {
            swal("There was an error!", response.message, "warning");
          }
        })
        .catch((err) => {
          swal("There was an error!", "more error details", "warning");
        });
    }
  }

  async function taxChecked(obj) {
    var taxObj = obj;
    if (taxObj.is_active) setIsTaxActive(false);
    else setIsTaxActive(true);

    taxObj.is_active = isTaxActive;
    await makePostRequest("tax/update", taxObj)
      .then((response) => {
        if (response.data.data !== undefined) {
          TaxListing();
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function TaxListing() {
    let bodyFormData = {};

    await makeGetRequest("tax/getall", bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          console.log("ttttt");
          console.log(response.data.data);
          // setlength(response.data.data.rowCount);
          const data = response.data.data;
          setTaxList(data);

          // new change added by me for late fee save

          const lateFeeTax = data.find((tax) => tax.tax_name === "Late Fee");
          if (lateFeeTax) {
            setgetLateFee(lateFeeTax.tax_amount);
          }
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function editNotes(notesId) {
    setEditNotesFlag(true);

    let bodyFormData = {};

    await makeGetRequest("notes/getbyid/" + notesId, bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          console.log("Notes details");
          console.log(response.data.data);
          setNotes(response.data.data.notes);
          setIsNotesActive(response.data.data.is_active);

          localStorage.setItem("editNotesId", notesId);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function handleCancelNotes() {
    setEditNotesFlag(false);
    setNotes("");
    setIsNotesActive(false);

    localStorage.removeItem("editNotesId");
  }

  async function saveNotes() {
    if (notes) {
      var inputdata = {
        notes: notes,
      };
      if (editNotesFlag) {
        inputdata.notes_id = localStorage.getItem("editNotesId");
        inputdata.is_active = isNotesActive;
        await makePostRequest("notes/update", inputdata)
          .then((response) => {
            if (response.data.data !== undefined) {
              // setNotes(0);
              NotesListing();
              swal("Success", "Notes updated successfully", "success", {
                timer: 1000,
                buttons: false,
              });
              setNotes("");
              localStorage.removeItem("editNotesId");
              setEditNotesFlag(false);
            }
          })
          .catch((err) => {
            swal("There was an error!", "more error details", "warning");
          });
      } else {
        inputdata.is_active = true;
        await makePostRequest("notes/insert", inputdata)
          .then((response) => {
            if (response.data.data !== undefined) {
              setNotes(0);
              NotesListing();
              swal("Success", "Notes added successfully", "success", {
                timer: 1000,
                buttons: false,
              });
              setNotes("");
            }
          })
          .catch((err) => {
            swal("There was an error!", "more error details", "warning");
          });
      }
    } else swal("Please add notes", "warning");
  }

  async function deleteNotes(notesId) {
    const willDelete = await swal({
      title: "Are you sure?",
      text: "Do you really want to delete these records? This process cannot be undone.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (willDelete) {
      let bodyFormData = {};

      await makeGetRequest("notes/delete/" + notesId, bodyFormData)
        .then((response) => {
          if (response.status == "201") {
            swal("Success", "Record deleted successfully", "success", {
              timer: 1000,
              buttons: false,
            });
            NotesListing();
          } else {
            swal("There was an error!", response.message, "warning");
          }
        })
        .catch((err) => {
          swal("There was an error!", "more error details", "warning");
        });
    }
  }

  async function notesChecked(obj) {
    var notesObj = obj;
    if (notesObj.is_active) setIsNotesActive(false);
    else setIsNotesActive(true);

    notesObj.is_active = isNotesActive;
    await makePostRequest("notes/update", notesObj)
      .then((response) => {
        if (response.data.data !== undefined) {
          NotesListing();
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function NotesListing() {
    let bodyFormData = {};

    await makeGetRequest("notes/getall", bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          console.log("Notes details Data");
          console.log(response.data.data);
          // setlength(response.data.data.rowCount);
          const data = response.data.data;
          setNotesList(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);

    // new change added by me

    setSelectedApartmentIds([]);
    setSelectedResidentIds([]);
    setselectedApart([]);
    setselectedResident([]);
    setselectedOption("");
    setIsSelectAllChecked(false);
    setIsSelectAllChecked(false);
    if (newValue == 4) {
      getSchedulerData();
      ownersListing();
    } else if (newValue == 5) {
      getSchedulerData();
    } else if (newValue == 6) {
      lateFeecalc();
    }
  };

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");

  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef(null);

  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }

    MaintenenceListing();
    BankDetailsListing();
    TaxListing();
    NotesListing();
    // setselectedApart(ownersList.map((data)=> data.apartment_id))

    setSubject(
      "Invoice for the month of " +
        moment(moment(invoice_date).utc().format("YYYY-MM-DD")).format("MMMM")
    );
  }, [open]);
  // End
  // React.useEffect(() => {
  //   setMaintenenceJsonList([]);
  // }, []);

  // For Modal 2
  const [open2, setOpen2] = React.useState(false);
  const [scroll2, setScroll2] = React.useState("paper");

  const handleClickOpen2 = (scrollType) => () => {
    setOpen2(true);
    setScroll2(scrollType);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  //  added by gautami new change
  // const [maintenenceJsonList, setMaintenenceJsonList] = React.useState([]);
  const lateFeecalc = async () => {
    setShowLoader(true);
    console.log("late fee", getLateFee);
    let inputdata = {
      current_date: invoice_date,
    };

    await makePostRequest("invoice/getinvoce", inputdata)
      .then(async (response) => {
        if (response.status == "201") {
          const data = response.data.data;
          console.log("re", response.data.data);
          console.log("len", response.data.data.length);
          if (data.length === 0) {
            setShowLoader(false);
            swal("No invoices found", "There are no invoices to update.", "");
            return;
          }

          const currentDate = moment(invoice_date);

          for (let i = 0; i < response.data.data.length; i++) {
            let result = response.data.data[i];

            console.log(result);

            const dueDate = moment(result.due_date);
            const monthDifference = currentDate.diff(dueDate, "months");
            let maintenanceTotal = 0;
            console.log("diff", monthDifference);

            maintenanceTotal = result.maintenance_total;
            console.log("m tot", maintenanceTotal);
            console.log(result.total_payment);
            let lateFee = 0;
            let lateFeeamt = 0;

            // lateFee = (maintenanceTotal * (monthDifference + 1)) / getLateFee;
            lateFeeamt = (maintenanceTotal * getLateFee) / 100;
            lateFee = lateFeeamt * (monthDifference + 1);
            console.log("late fee", lateFee);

            // let finalfee = lateFee.toFixed(2);
            let totalPay = (maintenanceTotal + lateFee).toFixed(2);

            console.log("totalPay", result.maintenence_json_list);

            const invId = result.invoice_id;
            let invoicetype = result.invoice_type;

            let calculated_Total = result.total_payment.toFixed(2);
            let oldLateFee = 0;
            let filteredmaintenence = result.maintenence_json_list.filter(
              (user) => {
                if (invoicetype == "Monthly Maintenance") {
                  if (user.key == "Late Fee") {
                    oldLateFee = parseFloat(user.total);
                  } else {
                    return user;
                  }
                } else {
                  if (user.name == "Late Fee") {
                    oldLateFee = parseFloat(user.total);
                  } else {
                    return user;
                  }
                }
              }
            );
            console.log("test", filteredmaintenence);
            console.log("Old Late Fee:", oldLateFee);
            // setMaintenenceJsonList(filteredmaintenence);
            let newmaint = filteredmaintenence;

            let miscellaneousJson;
            if (invoicetype == "Monthly Maintenance") {
              miscellaneousJson = { key: "", value: "", total: "" };
              miscellaneousJson.key = "Late Fee";
              miscellaneousJson.value = getLateFee;
              miscellaneousJson.total = parseFloat(lateFee.toFixed(2));
            } else {
              miscellaneousJson = { name: "", value: "", total: "" };
              miscellaneousJson.name = "Late Fee";
              miscellaneousJson.value = getLateFee;
              miscellaneousJson.total = parseFloat(lateFee.toFixed(2));
            }

            const newjsn = [...filteredmaintenence, miscellaneousJson];
            // maintenenceJsonList.push(newjsn);

            setMaintenenceJsonList([]);
            setMaintenenceJsonList((prevList) => [...prevList, newjsn]);

            console.log("fin jsn", newjsn);

            let fees = parseFloat(calculated_Total) - parseFloat(oldLateFee);
            let newfees = parseFloat(fees) + parseFloat(lateFee.toFixed(2));
            let totalpayamount = newfees.toFixed(2);
            console.log("totalpayamount", totalpayamount);
            // setShowLoader(false);
            // return false;

            // update invoice api

            let inputdata = {
              invoice_id: invId,
              total_payment: totalpayamount,
              maintenence_json_list: newjsn,
              late_fee: parseFloat(lateFee.toFixed(2)),
            };
            await makePostRequest("invoice/update", inputdata)
              .then((updateResponse) => {
                if (updateResponse.data.data !== undefined) {
                  // swal(
                  //   "Success",
                  //   "Late fee has been Updated Successully....",
                  //   "success",
                  //   {
                  //     timer: 1000,
                  //     buttons: false,
                  //   }
                  // );
                }
              })
              .catch((err) => {
                console.log(
                  `Error updating invoice ${result.invoice_id}: ${err.message}`
                );
              });
          }
          swal(
            "Success",
            "Late fee has been updated successully....",
            "success",
            {
              timer: 1000,
              buttons: false,
            }
          );
        } else {
          swal("There was an error!", response.message, "warning");
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  };

  // schedule invoice added by gautami
  async function ownersListing() {
    setShowLoader(true);
    await makeGetRequest("resident/getallresidentwithaprt")
      .then((response) => {
        if (response.status == "201") {
          const data = response.data.data;
          setOwnersList(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  // new

  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    setselectedApart(
      isChecked ? ownersList.map((user) => user.apartment_id) : []
    );
    setselectedResident(
      isChecked ? ownersList.map((user) => user.resident_id) : []
    );
    let aparmentarr = isChecked
      ? ownersList.map((user) => user.apartment_id)
      : [];
    let residentarr = isChecked
      ? ownersList.map((user) => user.resident_id)
      : [];
    console.log("appppp", aparmentarr);
    console.log("rrres", residentarr);
    setSelectedApartmentIds(aparmentarr);
    setSelectedResidentIds(residentarr);
    setIsSelectAllChecked(isChecked);
  };

  const handleUserCheckboxChange = (aprtId, resident_id, isChecked) => {
    const newSelectedApartid = [...selectedApart];
    const newSelectedResid = [...selectedResident];
    if (isChecked) {
      newSelectedApartid.push(aprtId);
      newSelectedResid.push(resident_id);
    } else {
      newSelectedApartid.splice(newSelectedApartid.indexOf(aprtId), 1);
      newSelectedResid.splice(newSelectedResid.indexOf(resident_id), 1);
    }
    setselectedApart(newSelectedApartid);
    setselectedResident(newSelectedResid);
    setSelectedApartmentIds(newSelectedApartid);
    setSelectedResidentIds(newSelectedResid);
    console.log("first", newSelectedApartid);
    console.log(newSelectedResid);
  };

 

  // for invoice data
  // maint cal

  const maintCalculation = async () => {
    console.log('1111', maintenenceList);
  
    const newMaintenenceJsonList = maintenenceList
      .filter(option => option.is_active)
      .map((option) => ({
        key: option.maintenence_type,
        value: option.amount,
      }))
      .filter((option) => option.key !== "" && option.value !== "");
  
    const newTaxJsonList = taxJsonList
    .filter(option => option.is_active)
      .map((option) => ({
        key: option.key,
        value: option.value,
        total: option.total,
      }))
      .filter((option) => option.key !== "" && option.value !== "");
  
    const combinedList = [...newMaintenenceJsonList, ...newTaxJsonList];
    console.log("combinedList", combinedList);
    return combinedList;
  };
  

  const taxcal = async (residentId, apartmentId) => {
    SetTaxJsonList([]);
    let taxListCopy = [...taxList];
    let tempTaxJsonList = [];

    var tax = 0;
    var previousMonthTotPayable = 0;
    var total = 0;
    var calculated_lateFee = 0;

    for (var k = 0; k < taxListCopy.length; k++) {
      taxJson = { key: "", value: "", total: "" };

      var calculatedTax;
      if (taxListCopy[k].tax_name === "Late Fee") {
        let latefeeAmt = taxListCopy[k].tax_amount;
        let previousInvoice = "";

        await makeGetRequest(
          "invoice/getpreviousmonth/" + residentId + "/" + apartmentId,
          ""
        )
          .then((response) => {
            if (response.status == "201") {
              previousInvoice = response.data.data;
              console.log("prev da", response.data.data);
            }
          })
          .catch((err) => {
            swal("There was an error!", "more error details", "warning");
          });

        if (previousInvoice) {
          if (previousInvoice.is_paid) {
            if (
              new Date(previousInvoice.paid_date).getTime() >
              new Date(previousInvoice.due_date).getTime()
            ) {
              calculated_lateFee =
                ((previousInvoice.total_payment -
                  previousInvoice.advance_received) *
                  latefeeAmt) /
                100;
              taxListCopy[k].calculatedTax = calculated_lateFee;
              tax = tax + calculated_lateFee;
              setLateFee(calculated_lateFee);
              console.log("aaa", tax);
            }
          } else {
            calculated_lateFee =
              ((previousInvoice.total_payment -
                previousInvoice.advance_received) *
                taxListCopy[k].tax_amount) /
              100;
            taxListCopy[k].calculatedTax = calculated_lateFee;
            tax = tax + calculated_lateFee;

            previousMonthTotPayable = previousInvoice.total_payment;
            setPastDue(previousMonthTotPayable);
            setLateFee(calculated_lateFee);
          }
        } else taxListCopy[k].calculatedTax = 0;
      } else {
        calculatedTax = (maintenenceTotal * taxListCopy[k].tax_amount) / 100;
        taxListCopy[k].calculatedTax = calculatedTax;
        tax = tax + calculatedTax;
      }
      taxJson.key = taxListCopy[k].tax_name;
      taxJson.value = taxListCopy[k].tax_amount;
      taxJson.total = taxListCopy[k].calculatedTax;
      // taxJsonList.push(taxJson);
      tempTaxJsonList.push(taxJson);
    }

    // console.log("bb", taxJsonList);
    // console.log("bb total", maintenenceTotal);
    SetTaxJsonList(tempTaxJsonList);
    // SetTaxJsonList(taxJsonList);
    setMaintenenceTotal(maintenenceTotal);
    setTaxTotal(tax);
    setSubTotal(maintenenceTotal);
    let taxwithtotal = parseFloat(maintenenceTotal) + parseFloat(tax);

    // console.log("taxtot", taxwithtotal);
    // console.log("tax", tax);
    if (parseFloat(advanceReceived) <= parseFloat(taxwithtotal)) {
      let actualtotal = parseFloat(taxwithtotal) - parseFloat(advanceReceived);
      setTotalPayable(actualtotal);
    } else {
      setTotalPayable(taxwithtotal);
      setAdvanceReceived(0);
    }

    let tototal = parseFloat(maintenenceTotal) + parseFloat(tax);
    setHiddenTotalPayable(parseFloat(tototal).toFixed(2));
    // return taxJsonList;

    return {
      taxJsonList: tempTaxJsonList,
      subTotal: maintenenceTotal,
      taxTotal: tax,
      totalPayable: parseFloat(taxwithtotal),
      advanceReceived,
      past_due: previousMonthTotPayable,
      lateFee: calculated_lateFee,
    };
  };

  const createInvoices = async () => {
    console.log("in func", selectedApartmentIds);
    // if (selectedApartmentIds.length === 0 || selectedResidentIds.length === 0) {
    //   swal("Warning", "Please select at least one resident", "warning");
    //   return;
    // }

    // for avoid single user invoice creation added on 20-9-2024
    if (selectedApartmentIds.length < ownersList.length || selectedResidentIds.length < ownersList.length) {
      swal("Warning", "Please select all resident", "warning");
      return;
    }
    if (selectedApartmentIds.length !== selectedResidentIds.length) {
      swal(
        "Warning",
        "Mismatch between apartment IDs and resident IDs",
        "warning"
      );
      return;
    }
    // new change
    if (selectedOption == "" || selectedOption == undefined) {
      swal("Warning", "Please update your scheduler setting", "warning");
      setSelectedApartmentIds([]);
      setSelectedResidentIds([]);
      setselectedApart([]);
      setselectedResident([]);
      setIsSelectAllChecked(false);
      return;
    }
    try {
      setShowLoader(true);
      // setflagbtndisable(true);
      for (let i = 0; i < selectedApartmentIds.length; i++) {
        const apartmentId = selectedApartmentIds[i];
        const residentId = selectedResidentIds[i];

        const userData = await taxcal(residentId, apartmentId);
        const maincal = await maintCalculation();
        const combinedData = [...maincal, ...userData.taxJsonList];
        const response = await saveInvoice(
          residentId,
          apartmentId,
          userData,
          combinedData
        );
      }

      // added new changes update scheduler table

      let nextUpdateDate;
    
      let passdt = moment(currentDate).utc();
      // passdt.add(3, 'months').format("YYYY-MM-DD");
      if (selectedOption === "Monthly") {
        // nextUpdateDate = handleAddOneMonth(currentDate);
        nextUpdateDate = (moment(currentDate).add(1, "month"));
        //  nextUpdateDate = passdt.add(1, 'month').format("YYYY-MM-DD");
      } else if (selectedOption === "Quarterly") {
        // nextUpdateDate = handleAddThreeMonths(currentDate);
        nextUpdateDate = (moment(currentDate).add(3, "month"));
        // nextUpdateDate = passdt.add(3, 'month').format("YYYY-MM-DD");
      } else if (selectedOption === "Annual") {
        // nextUpdateDate = handleAddOneYear(currentDate);
        nextUpdateDate = (moment(currentDate).add(1, "year"));
        // nextUpdateDate = passdt.add(1, 'year').format("YYYY-MM-DD");
      } else {
        nextUpdateDate = null;
      }
console.log("nxt dt",nextUpdateDate)
      if (nextUpdateDate !== null) {
        let inputdata = {
          // stype: selectedOption,
          current_date: moment(currentDate).format("YYYY-MM-DD"),
          end_date: moment(nextUpdateDate).format("YYYY-MM-DD"),
          sid: schedulerId,
        };
        const insertResponse = await makePostRequest(
          "invoice/updateSchedulerData",
          inputdata
        )
          .then((response) => {
            console.log("first", response.data.data);
            if (response.data.data !== undefined) {
              // swal("Success", "Scheduler update successfully", "success", {
              //   timer: 1000,
              //   buttons: false,
              // });
            }
          })
          .catch((err) => {
            console.log("nnn", err);
            swal("There was an error!", "more error details", "warning");
            // swal("There was an error!", "More error details: " + err.message, "warning");
          });
      }

      swal("Success", "Invoices added successfully", "success", {
        timer: 1000,
        buttons: false,
      });
      setShowLoader(false);
      // Reset selections
      setSelectedApartmentIds([]);
      setSelectedResidentIds([]);
      setselectedApart([]);
      setselectedResident([]);
      // setselectedOption("");
      setIsSelectAllChecked(false);
      setflagbtndisable(true);
    } catch (error) {
      setShowLoader(false);
      console.error(`Error creating invoice`, error);
      swal("There was an error!", "more error details", "warning");
    }
  };

  const handleAddOneMonth = (invoice_date) => {
    setenddate(dayjs(invoice_date).add(1, "month"));
    console.log('1m',dayjs(invoice_date).add(1, "month"))
  };

  const handleAddThreeMonths = (invoice_date) => {
    setenddate(dayjs(invoice_date).add(3, "month"));
    console.log('3m',dayjs(invoice_date).add(3, "month"))
  };

  const handleAddOneYear = (invoice_date) => {
    setenddate(dayjs(invoice_date).add(1, "year"));
  };
  async function saveInvoice(resId, aprtId, userData, maincal) {
    let inputdata;

    console.log("after tax===>" + JSON.stringify(maincal));

    // let sum = taxJsonList.map(o => o.total).reduce((a, c) => { return a + c });

    let newTotals = 0;

    newTotals = parseFloat(userData.subTotal) + parseFloat(userData.taxTotal);

    console.log("sub to", userData.subTotal);
    console.log("taxTotal", userData.taxTotal);
    console.log("new", newTotals);
    // return false;

    inputdata = {
      invoice_date: invoice_date,
      due_date: due_date,
      invoice_type: "Monthly Maintenance",
      resident_id: resId,
      apartment_id: aprtId,
      subject: subject,

      maintenence_json_list: maincal,
      total_payment: newTotals,
      advance_received: advanceReceived,
      is_paid: false,
      past_due: userData.past_due,
      late_fee: userData.lateFee,
      invoice_note: "",
      maintenance_total: parseFloat(maintenenceTotal)
    };

    await makePostRequest("invoice/insert", inputdata)
      .then((response) => {
        console.log("first", response.data.data);
        // if (response.data.data !== undefined) {

        //   swal("Success", "Invoice added successfully", "success", {
        //     timer: 1000,
        //     buttons: false,
        //   });
        //   setSelectedApartmentIds([])
        //  setSelectedResidentIds([])
        //  setselectedApart([])
        //  setselectedResident([])
        //  setselectedOption("")
        // }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
        // swal("There was an error!", "More error details: " + err.message, "warning");
      });
  }

  // for scheduler setting
  //   const saveSchedulermy = async () => {
  //     if (selectedOption !== "") {
  //       let inputdata = {
  //         stype: selectedOption,
  //       };

  // // 1st chk existing option
  // await makeGetRequest("invoice/getSchedulerData")
  //       .then((response) => {
  //         if (response.status == "201") {
  //           console.log(response.data.data.length);
  //           if (response.data.data.length > 0) {
  //           const existingRecord = response.data.data[0].stype;

  //           if (existingRecord) {
  //         // If the record exists, update it
  //         const updateResponse = await makePostRequest("invoice/schedulerUpdate", {
  //           ...inputdata,
  //           id: existingRecord.id, // Assuming there's an ID to identify the record
  //         });

  //         if (updateResponse.data.data !== undefined) {
  //           swal("Success", "Scheduler updated successfully", "success", {
  //             timer: 1000,
  //             buttons: false,
  //           });
  //           setselectedOption("");
  //         }
  //       }
  //           } else {
  //             console.log("No data available");
  //             // insert
  //   await makePostRequest("invoice/schedulerinsert", inputdata)
  //         .then((response) => {
  //           console.log("first", response.data.data);
  //           if (response.data.data !== undefined) {
  //             swal("Success", "Scheduler added successfully", "success", {
  //               timer: 1000,
  //               buttons: false,
  //             });
  //             setselectedOption("");
  //           }
  //         })
  //         .catch((err) => {
  //           swal("There was an error!", "more error details", "warning");
  //           // swal("There was an error!", "More error details: " + err.message, "warning");
  //         });

  //           }
  //         } else {
  //           swal("There was an error!", response.message, "warning");
  //         }
  //         setShowLoader(false);
  //       })
  //       .catch((err) => {
  //         console.log("first",err)
  //         setShowLoader(false);
  //         swal(" There was an error!", "more error details", "warning");
  //       });

  //       // if (existingRecord) {
  //       //   // If the record exists, update it
  //       //   const updateResponse = await makePostRequest("invoice/schedulerUpdate", {
  //       //     ...inputdata,
  //       //     id: existingRecord.id, // Assuming there's an ID to identify the record
  //       //   });

  //       //   if (updateResponse.data.data !== undefined) {
  //       //     swal("Success", "Scheduler updated successfully", "success", {
  //       //       timer: 1000,
  //       //       buttons: false,
  //       //     });
  //       //     setselectedOption("");
  //       //   }
  //       // } else {

  //       // await makePostRequest("invoice/schedulerinsert", inputdata)
  //       //   .then((response) => {
  //       //     console.log("first", response.data.data);
  //       //     if (response.data.data !== undefined) {
  //       //       swal("Success", "Scheduler added successfully", "success", {
  //       //         timer: 1000,
  //       //         buttons: false,
  //       //       });
  //       //       setselectedOption("");
  //       //     }
  //       //   })
  //       //   .catch((err) => {
  //       //     swal("There was an error!", "more error details", "warning");
  //       //     // swal("There was an error!", "More error details: " + err.message, "warning");
  //       //   });
  //       // }
  //     } else {
  //       swal("Warning", "Please select one option", "warning");
  //     }
  //   };

  // new



  // added by me for scheduler setting

  const saveScheduler = async () => {
    if (selectedOption !== "") {
      let inputdata = {
        stype: selectedOption,
      };

      const response = await makeGetRequest("invoice/getSchedulerData")
        .then((response) => {
          if (response.status == "201") {
            if (response.data.data.length > 0) {
              const existingRecord = response.data.data[0].stype;

              if (existingRecord) {
                // If the record exists update
                // setEditflag(true)
                updateResponse(response.data.data[0].sid);
              }
            } else {
              console.log("No data available");
              // Insert new record
              insertData();
            }
          } else {
            swal("There was an error!", response.message, "warning");
          }
        })
        .catch((err) => {
          console.log("first", err);
          setShowLoader(false);
          swal("There was an error!", "more error details", "warning");
        });
    } else {
      swal("Warning", "Please select one option", "warning");
    }
  };

  const insertData = async () => {
    setShowLoader(true)
    let inputdata = {
      stype: selectedOption,
    };
    const insertResponse = await makePostRequest(
      "invoice/schedulerinsert",
      inputdata
    )
      .then((response) => {
        // console.log("first", response.data.data);
        if (response.data.data !== undefined) {
          swal("Success", "Scheduler added successfully", "success", {
            timer: 1000,
            buttons: false,
          });
          setselectedOption(selectedOption);
          setShowLoader(false)
        }
      })
      .catch((err) => {
        setShowLoader(false)
        console.log(err);
        swal("There was an error!", "more error details", "warning");
      });
  };

// for test

// const testforfirsttime = async() => {
//   let nextUpdateDate;
    
//   let passdt = moment(currentDate).utc();
//   // passdt.add(3, 'months').format("YYYY-MM-DD");
//   if (selectedOption === "Monthly") {
//     // nextUpdateDate = handleAddOneMonth(currentDate);
//     nextUpdateDate = (moment(currentDate).add(1, "month"));
//     //  nextUpdateDate = passdt.add(1, 'month').format("YYYY-MM-DD");
//   } else if (selectedOption === "Quarterly") {
//     // nextUpdateDate = handleAddThreeMonths(currentDate);
//     nextUpdateDate = (moment(currentDate).add(3, "month"));
//     // nextUpdateDate = passdt.add(3, 'month').format("YYYY-MM-DD");
//   } else if (selectedOption === "Annual") {
//     // nextUpdateDate = handleAddOneYear(currentDate);
//     nextUpdateDate = (moment(currentDate).add(1, "year"));
//     // nextUpdateDate = passdt.add(1, 'year').format("YYYY-MM-DD");
//   } else {
//     nextUpdateDate = null;
//   }
// console.log("nxt dt",nextUpdateDate)
//   if (nextUpdateDate !== null) {
//     let inputdata = {
//       // stype: selectedOption,
//       current_date: moment(currentDate).format("YYYY-MM-DD"),
//       end_date: moment(nextUpdateDate).format("YYYY-MM-DD"),
//       sid: schedulerId,
//     };
//     const insertResponse = await makePostRequest(
//       "invoice/updateSchedulerData",
//       inputdata
//     )
//       .then((response) => {
//         console.log("first", response.data.data);
//         if (response.data.data !== undefined) {
//           // swal("Success", "Scheduler update successfully", "success", {
//           //   timer: 1000,
//           //   buttons: false,
//           // });
//         }
//       })
//       .catch((err) => {
//         console.log("nnn", err);
//         swal("There was an error!", "more error details", "warning");
//         // swal("There was an error!", "More error details: " + err.message, "warning");
//       });
//   }
// }








  const updateResponse = async (sid) => {
    setShowLoader(true)
    console.log('in up',moment(enddate).format("YYYY-MM-DD"))
    console.log(dtforupdate)

    let nextUpdateDate;

    if (selectedOption === "Monthly" && dtforupdate!=undefined) {
      // handleAddOneMonth(dtforupdate);
      // setenddate(dayjs(dtforupdate).add(1, "month"));
      // console.log('1111',dayjs(dtforupdate).add(1, "month"))
      nextUpdateDate = (moment(dtforupdate).add(1, "month"));
    } else if (selectedOption === "Quarterly" && dtforupdate!=undefined) {
      // handleAddThreeMonths(dtforupdate);
      nextUpdateDate =(moment(dtforupdate).add(3, "month"));
  
    } else if (selectedOption === "Annual" && dtforupdate!=undefined) {
      // handleAddOneYear(dtforupdate);
      nextUpdateDate =(moment(dtforupdate).add(1, "year"));
    } else {
      nextUpdateDate =null;
    }
    console.log("first",nextUpdateDate)
    console.log('1111',nextUpdateDate ? moment(nextUpdateDate).format("YYYY-MM-DD") : null)
  // return
    let inputdata = {
      end_date: nextUpdateDate ? moment(nextUpdateDate).format("YYYY-MM-DD") : null,
      stype: selectedOption,
      sid: sid,
    };
    const insertResponse = await makePostRequest(
      "invoice/updateSchedulerData",
      inputdata
    )
      .then((response) => {
        console.log("first", response.data.data);
        if (response.data.data !== undefined) {
          swal("Success", "Scheduler update successfully", "success", {
            timer: 1000,
            buttons: false,
          });
          setselectedOption("");
          getSchedulerData();
          setShowLoader(false)
        }
      })
      .catch((err) => {
        setShowLoader(false)
        swal("There was an error!", "more error details", "warning");
        // swal("There was an error!", "More error details: " + err.message, "warning");
      });
  };


  const handleOptionChange = async (e) => {
    setselectedOption(e.target.value);
    console.log('chnge',dtforupdate)
    // let cdate = dayjs(res.current_date);
    // if (e.target.value === "Monthly" && dtforupdate!=undefined) {
    //   // handleAddOneMonth(dtforupdate);
    //   setenddate(dayjs(dtforupdate).add(1, "month"));
    //   console.log('1111',dayjs(dtforupdate).add(1, "month"))
    // } else if (e.target.value === "Quarterly" && dtforupdate!=undefined) {
    //   // handleAddThreeMonths(dtforupdate);
    //   setenddate(dayjs(dtforupdate).add(3, "month"));
    //   console.log('3333',dayjs(dtforupdate).add(3, "month"))
    // } else if (e.target.value === "Annual" && dtforupdate!=undefined) {
    //   // handleAddOneYear(dtforupdate);
    //   setenddate(dayjs(dtforupdate).add(1, "year"));
    // } else {
    //   setenddate(null);
    // }
  };

  async function getSchedulerData() {
    setShowLoader(true);
    await makeGetRequest("invoice/getSchedulerData")
      .then((response) => {
        if (response.status == "201") {
          console.log(response.data.data.length);
          if (response.data.data.length > 0) {
            setselectedOption(response.data.data[0].stype);
            setschedulerId(response.data.data[0].sid);
            console.log("end dt", response.data.data[0].end_date);

            console.log("start dt", response.data.data[0].current_date);
            console.log("hooks",currentDate)
            // const endDate = response.data.data[0].end_date
            //   ? dayjs(response.data.data[0].end_date)
            //   : null;
            // const current_Date = response.data.data[0].current_date
            //   ? dayjs(response.data.data[0].current_date)
            //   : null;
          //   const endDate = response.data.data[0].end_date
          //   ? moment(response.data.data[0].end_date).format("YYYY-MM-DD")
          //   : null;
          // const current_Date = moment(currentDate).format("YYYY-MM-DD")
          //   ? moment(currentDate).format("YYYY-MM-DD")
          //   : null;

            // const respcdt = moment(currentDate).format("YYYY-MM-DD")
            // ? moment(currentDate).format("YYYY-MM-DD")
            // : null;

            let endDate
            let current_Date
            // setdtforupdate(current_Date);
            if (response.data.data[0].current_date) {

    endDate = response.data.data[0].end_date
            ? moment(response.data.data[0].end_date).format("YYYY-MM-DD")
            : null;
           current_Date = moment(currentDate).format("YYYY-MM-DD")
            ? moment(currentDate).format("YYYY-MM-DD")
            : null;
              // endDate= response.data.data[0].end_date
              // ? dayjs(response.data.data[0].end_date)
              // : null;
              // current_Date= response.data.data[0].current_date
              // ? dayjs(response.data.data[0].current_date)
              // : null;


              console.log("in if",response.data.data[0].current_date)
              const dt = response.data.data[0].current_date
              ? moment(response.data.data[0].current_date).format("YYYY-MM-DD")
              : null;
              console.log("in if yyyy",dt)
              // setdtforupdate(dt)
              setdtforupdate(dt)
            } else {
              console.log("in els")
              endDate=null;
              current_Date=null
              setdtforupdate(null)
            }
            console.log("end dt fin", endDate);
            console.log("curr", current_Date);

            if (
              current_Date >= endDate || endDate === null
            ) {
              console.log("show");
              setflagbtndisable(false);
            } else {
              console.log("disab");
              setflagbtndisable(true);
            }
          } else {
            console.log("No data available");
            setselectedOption("");
            // endDate=null;
            // current_Date=null
            setdtforupdate(null)
          }
        } else {
          swal("There was an error!", response.message, "warning");
        }
        setShowLoader(false);
      })
      .catch((err) => {
        console.log("first", err);
        setShowLoader(false);
        swal(" There was an error!", "more error details", "warning");
      });
  }

  const descriptionElementRef2 = React.useRef(null);
  React.useEffect(() => {
    if (open2) {
      const { current: descriptionElement } = descriptionElementRef2;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open2]);
  // End

  return (
    <>
      <div>
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="scrollable auto tabs example"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="Maintenance" {...a11yProps(0)} />
              <Tab label="Manage Notes" {...a11yProps(1)} />
              <Tab label="Manage Bank" {...a11yProps(2)} />
              <Tab label="Manage Tax And Late Fee" {...a11yProps(3)} />
              {/* <Tab label="Other" {...a11yProps(4)} /> */}
              <Tab label="Schedule Invoice" {...a11yProps(4)} />

              {/* for late fee update calculation */}
              {/* <Tab label="Late Fees" {...a11yProps(5)} /> */}
              <Tab label="Scheduler Setting" {...a11yProps(5)} />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <Grid container spacing={3} style={{ marginTop: "10px" }}>
              {maintenenceList.map((option) => (
                <Grid item xs={12} md={6}>
                  <div className="visitContDiv contentMark">
                    {option.is_active ? (
                      <div className="contentMarkInactive contentMarkActive">
                        <CheckIcon onClick={() => maintenenceChecked(option)} />
                      </div>
                    ) : (
                      <div className="contentMarkInactive ">
                        <CheckIcon onClick={() => maintenenceChecked(option)} />
                      </div>
                    )}
                    <div className="visitCont1 resideNewContOut maitnaMain maitnaMainNew">
                      <div className="visitBottCont">
                        <p>Maintenance Type</p>
                        <b>{option.maintenence_type}</b>
                      </div>
                      <div className="visitBottContOuter">
                        <div className="visitBottCont">
                          <p>Amount</p>
                          <b>
                            <CurrencyRupeeIcon /> {option.amount}
                          </b>
                        </div>
                        <div className="resideNewCont">
                          <CreateIcon
                            className="editBt"
                            onClick={() =>
                              editMaintenence(option.maintenence_id)
                            }
                          />
                          <DeleteIcon
                            className="deleteBt"
                            onClick={() =>
                              deleteMaintenence(option.maintenence_id)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
              ))}
              {/*For Append */}
              {/* {[...Array(count)].map((_, i) => (
                <AddedElement key={i} />
              ))} */}
              {/* End */}

              <Grid item xs={12} md={12}>
                <Formik
                  enableReinitialize
                  initialValues={formikInitials}
                  validationSchema={Validation_Schema}
                  onSubmit={saveMaintenence}
                >
                  {({
                    values,
                    handleChange,
                    errors,
                    setFieldTouched,
                    touched,
                    isValid,
                    handleSubmit,
                  }) => (
                    <Form>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={9}>
                          {/* {maintenenceList.map(option=>( */}
                          <div style={{ position: "relative" }}>
                            <input
                              type="text"
                              className="inputSt"
                              placeholder="Maintenence Type"
                              value={maintenence_type}
                              onChange={handleChange("maintenence_type")}
                              onBlur={() => setFieldTouched("maintenence_type")}
                              onChangeCapture={(e) =>
                                setMaintenence_type(e.target.value)
                              }
                            />
                            {errors.maintenence_type &&
                            touched.maintenence_type ? (
                              <div
                                style={{ color: "red" }}
                                className="errorField"
                              >
                                {errors.maintenence_type}
                              </div>
                            ) : null}
                          </div>
                          {/* ))} */}
                        </Grid>
                        <Grid item xs={12} md={3}>
                          {/* {maintenenceList.map(option=>( */}
                          <div>
                            <input
                              type="text"
                              className="inputSt"
                              placeholder="Amount"
                              value={amount}
                              onChange={handleChange("amount")}
                              onBlur={() => setFieldTouched("amount")}
                              onChangeCapture={(e) => setAmount(e.target.value)}
                            />
                            {errors.amount && touched.amount ? (
                              <div
                                style={{ color: "red" }}
                                className="errorField"
                              >
                                {errors.amount}
                              </div>
                            ) : null}
                          </div>

                          {/* ))} */}
                        </Grid>
                      </Grid>

                      <Grid item xs={12} md={12}>
                        {editMaintenenceFlag ? (
                          <Button
                            className="addNotesBtn addNotesBtnCncl"
                            onClick={() => handleCancelMaintenance()}
                          >
                            <div>Cancel</div>
                          </Button>
                        ) : (
                          <></>
                        )}

                        <Button
                          type="submit"
                          className="addNotesBtn addNotesBtnBg"
                          // onClick={() => saveMaintenence()}
                        >
                          {editMaintenenceFlag ? (
                            <div>Edit Maintenence</div>
                          ) : (
                            <div>
                              <AddIcon /> Add Maintenance
                            </div>
                          )}
                        </Button>
                      </Grid>
                    </Form>
                  )}
                </Formik>
              </Grid>
            </Grid>
          </TabPanel>

          <TabPanel value={value} index={1}>
            <Grid container spacing={3} style={{ marginTop: "10px" }}>
              {notesList.map((option) => (
                <Grid item xs={12} md={6}>
                  <div className="visitContDiv contentMark">
                    {option.is_active ? (
                      <div className="contentMarkInactive contentMarkActive">
                        <CheckIcon onClick={() => notesChecked(option)} />
                      </div>
                    ) : (
                      <div className="contentMarkInactive ">
                        <CheckIcon onClick={() => notesChecked(option)} />
                      </div>
                    )}
                    <div className="visitCont1 resideNewContOut maitnaMain">
                      <div className="visitBottCont">
                        <b>{option.notes}</b>
                      </div>
                      <div className="resideNewCont">
                        <CreateIcon
                          className="editBt"
                          onClick={() => editNotes(option.notes_id)}
                        />
                        <DeleteIcon
                          className="deleteBt"
                          onClick={() => deleteNotes(option.notes_id)}
                        />
                      </div>
                    </div>
                  </div>
                </Grid>
              ))}
              <Grid item xs={12} md={12}>
                <Formik
                  enableReinitialize
                  initialValues={formikInitials_notes}
                  validationSchema={Validation_Schema_Notes}
                  onSubmit={saveNotes}
                >
                  {({
                    values,
                    handleChange,
                    errors,
                    setFieldTouched,
                    touched,
                    isValid,
                    handleSubmit,
                  }) => (
                    <Form>
                      <input
                        type="text"
                        className="inputSt"
                        placeholder="Type here."
                        value={notes}
                        onChange={handleChange("notes")}
                        onBlur={() => setFieldTouched("notes")}
                        onChangeCapture={(e) => setNotes(e.target.value)}
                      />
                      {errors.notes && touched.notes ? (
                        <div style={{ color: "red" }} className="errorField">
                          {errors.notes}
                        </div>
                      ) : null}

                      <Grid item xs={12} md={12}>
                        <Button
                          className="addNotesBtn addNotesBtnCncl"
                          onClick={() => handleCancelNotes()}
                        >
                          <div>Cancel</div>
                        </Button>

                        <Button
                          type="submit"
                          className="addNotesBtn addNotesBtnBg"
                        >
                          {editNotesFlag ? (
                            <div>Edit Notes</div>
                          ) : (
                            <div>
                              <AddIcon /> Add Notes
                            </div>
                          )}
                        </Button>
                      </Grid>
                    </Form>
                  )}
                </Formik>
              </Grid>
            </Grid>
          </TabPanel>

          <TabPanel value={value} index={2}>
            <Grid container spacing={3} style={{ marginTop: "20px" }}>
              {bankDetailsList.map((option) => (
                <Grid item xs={12} md={12}>
                  {option.invoice_type == "Monthly Maintenance" &&
                  option.is_active == true ? (
                    <h4 className="bankHeading">
                      Primary account for Monthly Maintenence Invoice
                    </h4>
                  ) : option.invoice_type == "Miscellaneous" &&
                    option.is_active == true ? (
                    <h4 className="bankHeading">
                      Primary account for Miscellaneous Invoice
                    </h4>
                  ) : (
                    <h4 className="bankHeading">Other Accounts</h4>
                  )}
                  <div className="visitContDiv contentMark">
                    {option.is_active ? (
                      <div className="contentMarkInactive contentMarkActive">
                        <CheckIcon onClick={() => bankDetailsChecked(option)} />
                      </div>
                    ) : (
                      <div className="contentMarkInactive ">
                        <CheckIcon onClick={() => bankDetailsChecked(option)} />
                      </div>
                    )}
                    <div className="visitCont1 resideNewContOut maitnaMain">
                      <div className="visitBottCont">
                        <p>Account Holder</p>
                        <b>{option.account_holder}</b>
                      </div>
                      <div className="visitBottCont">
                        <p>Account Type</p>
                        <b>{option.account_type}</b>
                      </div>
                      <div className="visitBottCont">
                        <p>Account No.</p>
                        <b>{option.account_no}</b>
                      </div>
                      <div className="visitBottCont">
                        <p>Bank Name</p>
                        <b>{option.bank_name}</b>
                      </div>
                      <div className="visitBottCont">
                        <p>IFSC Code</p>
                        <b>{option.ifsc_code}</b>
                      </div>
                      <div className="visitBottCont">
                        <p>UPI ID</p>
                        <b>{option.upi_id}</b>
                      </div>
                      <div className="visitBottCont">
                        <p>MICR Code</p>
                        <b>{option.micr_code}</b>
                      </div>
                      <div className="visitBottCont">
                        <p>Invoice Type</p>
                        <b>{option.invoice_type}</b>
                      </div>
                      <div className="resideNewCont">
                        <CreateIcon
                          className="editBt"
                          onClick={() =>
                            editBankDetails(option.bank_details_id)
                          }
                        />
                        <DeleteIcon
                          className="deleteBt"
                          onClick={() =>
                            deleteBankDetails(option.bank_details_id)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </Grid>
              ))}

              <Grid item xs={12} md={12}>
                <Formik
                  enableReinitialize
                  initialValues={formikInitials_BankDetails}
                  validationSchema={Validation_Schema_BankDetails}
                  onSubmit={saveBankDetails}
                >
                  {({
                    values,
                    handleChange,
                    errors,
                    setFieldTouched,
                    touched,
                    isValid,
                    handleSubmit,
                  }) => (
                    <Form>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">Account Holder</label>
                          <input
                            type="text"
                            className="inputSt"
                            placeholder="Account Holder Name"
                            value={account_holder}
                            onChange={handleChange("account_holder")}
                            onBlur={() => setFieldTouched("account_holder")}
                            onChangeCapture={(e) =>
                              setAccount_holder(e.target.value)
                            }
                          />
                          {errors.account_holder && touched.account_holder ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.account_holder}
                            </div>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">Account Type</label>
                          <input
                            type="text"
                            className="inputSt"
                            placeholder="Saving Account"
                            value={account_type}
                            onChange={handleChange("account_type")}
                            onBlur={() => setFieldTouched("account_type")}
                            onChangeCapture={(e) =>
                              setAccount_type(e.target.value)
                            }
                          />
                          {errors.account_type && touched.account_type ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.account_type}
                            </div>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">Account No.</label>
                          <input
                            type="text"
                            className="inputSt"
                            placeholder="178698088990"
                            value={account_no}
                            onChange={handleChange("account_no")}
                            onBlur={() => setFieldTouched("account_no")}
                            onChangeCapture={(e) =>
                              setAccount_no(e.target.value)
                            }
                          />
                          {errors.account_no && touched.account_no ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.account_no}
                            </div>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">Bank Name</label>
                          <input
                            type="text"
                            className="inputSt"
                            placeholder="ICICI Bank"
                            value={bank_name}
                            onChange={handleChange("bank_name")}
                            onBlur={() => setFieldTouched("bank_name")}
                            onChangeCapture={(e) => setBankName(e.target.value)}
                          />
                          {errors.bank_name && touched.bank_name ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.bank_name}
                            </div>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">IFSC Code</label>
                          <input
                            type="text"
                            className="inputSt"
                            placeholder="ICICI900800"
                            value={ifsc_code}
                            onChange={handleChange("ifsc_code")}
                            onBlur={() => setFieldTouched("ifsc_code")}
                            onChangeCapture={(e) => setIfscCode(e.target.value)}
                          />
                          {errors.ifsc_code && touched.ifsc_code ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.ifsc_code}
                            </div>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">MICR Code</label>
                          <input
                            type="text"
                            className="inputSt"
                            placeholder="ICICI900800"
                            value={micr_code}
                            onChange={handleChange("micr_code")}
                            onBlur={() => setFieldTouched("micr_code")}
                            onChangeCapture={(e) =>
                              setMicr_code(e.target.value)
                            }
                          />
                          {errors.micr_code && touched.micr_code ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.micr_code}
                            </div>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">UPI ID</label>
                          <input
                            type="text"
                            className="inputSt"
                            placeholder="paradisehousing@icici"
                            value={upi_id}
                            onChange={handleChange("upi_id")}
                            onBlur={() => setFieldTouched("upi_id")}
                            onChangeCapture={(e) => setUpiId(e.target.value)}
                          />
                          {errors.upi_id && touched.upi_id ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.upi_id}
                            </div>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">Bank Address</label>
                          <input
                            type="text"
                            className="inputSt"
                            placeholder="Lam Road, California"
                            value={address}
                            onChange={handleChange("address")}
                            onBlur={() => setFieldTouched("address")}
                            onChangeCapture={(e) => setAddress(e.target.value)}
                          />
                          {errors.address && touched.address ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.address}
                            </div>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <div className="manageBnkCheck">
                            <b>This account is for:</b>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    onChange={(e) =>
                                      handleChangeCheckBox(
                                        e,
                                        "Monthly Maintenance"
                                      )
                                    }
                                  />
                                }
                                label="Monthly Maintenance"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    onChange={(e) =>
                                      handleChangeCheckBox(e, "Miscellaneous")
                                    }
                                  />
                                }
                                label="miscellaneous"
                              />
                            </FormGroup>
                          </div>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <Button
                          className="addNotesBtn addNotesBtnCncl"
                          onClick={() => handleCancelBankDetails()}
                        >
                          <div>Cancel</div>
                        </Button>
                        <Button
                          type="submit"
                          className="addNotesBtn addNotesBtnBg"
                        >
                          {editBankDetailsFlag ? (
                            <div>Edit Bank Details</div>
                          ) : (
                            <div>
                              {" "}
                              <AddIcon /> Add Bank Details
                            </div>
                          )}
                        </Button>
                      </Grid>
                    </Form>
                  )}
                </Formik>
              </Grid>
            </Grid>
          </TabPanel>

          <TabPanel value={value} index={3}>
            <Grid container spacing={3} style={{ marginTop: "20px" }}>
              {taxList.map((option) => (
                <Grid item xs={12} md={6}>
                  <div className="visitContDiv contentMark">
                    {option.tax_name !== "Late Fee" && (
                      <>
                        {option.is_active ? (
                          <div className="contentMarkInactive contentMarkActive">
                            <CheckIcon onClick={() => taxChecked(option)} />
                          </div>
                        ) : (
                          <div className="contentMarkInactive">
                            <CheckIcon onClick={() => taxChecked(option)} />
                          </div>
                        )}
                      </>
                    )}
                    <div className="visitCont1 resideNewContOut maitnaMain">
                      <div className="visitBottCont">
                        <p>Name</p>
                        <b>{option.tax_name}</b>
                      </div>
                      <div className="visitBottCont">
                        <p>Tax In %</p>
                        <b>{option.tax_amount}%</b>
                      </div>

                      <div className="resideNewCont">
                        <CreateIcon
                          className="editBt"
                          onClick={() => editTax(option.tax_id)}
                        />
                        {option.tax_name !== "Late Fee" && (
                          <DeleteIcon
                            className="deleteBt"
                            onClick={() => deleteTax(option.tax_id)}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </Grid>
              ))}

              <Grid item xs={12} md={12}>
                <Formik
                  enableReinitialize
                  initialValues={
                    editTaxJson == null ? formikInitials_tax : editTaxJson
                  }
                  validationSchema={Validation_Schema_Tax}
                  onSubmit={saveTax}
                >
                  {({
                    values,
                    handleChange,
                    errors,
                    setFieldTouched,
                    touched,
                    isValid,
                    handleSubmit,
                  }) => (
                    <Form>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">Tax Name</label>
                          <input
                            type="text"
                            className="inputSt"
                            placeholder="CGST"
                            id="tax_name"
                            value={tax_name}
                            onChange={handleChange("tax_name")}
                            onBlur={() => setFieldTouched("tax_name")}
                            onChangeCapture={(e) => setTaxName(e.target.value)}
                          />
                          {errors.tax_name && touched.tax_name ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.tax_name}
                            </div>
                          ) : (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {taxErrMsg}
                            </div>
                          )}
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">
                            Applicable Tax in %
                          </label>
                          <input
                            type="text"
                            className="inputSt"
                            placeholder="Tax in %"
                            value={tax_amount}
                            onChange={handleChange("tax_amount")}
                            onBlur={() => setFieldTouched("tax_amount")}
                            onChangeCapture={(e) =>
                              setTaxAmount(e.target.value)
                            }
                          />
                          {errors.tax_amount && touched.tax_amount ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.tax_amount}
                            </div>
                          ) : null}
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <Button
                            className="addNotesBtn addNotesBtnCncl"
                            onClick={() => handleCancelTax()}
                          >
                            <div>Cancel</div>
                          </Button>

                          <Button
                            className="addNotesBtn addNotesBtnBg"
                            type="submit"
                          >
                            {editTaxFlag ? (
                              <div>Edit Tax</div>
                            ) : (
                              <div>
                                <AddIcon />
                                Add Tax
                              </div>
                            )}
                          </Button>
                        </Grid>
                      </Grid>
                    </Form>
                  )}
                </Formik>
              </Grid>
            </Grid>
          </TabPanel>

          <TabPanel value={value} index={4}>
            <div className="visitorListNewOut">
              <div className="visitorListNewInner">
                <Grid container spacing={3}>
                  <Grid item xs={12} md={12}>
                    <div className="maintaCheckOut myNewCheck">
                      <label className="forSelectSocietyLabel">
                        Invoice For :
                      </label>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isSelectAllChecked}
                              // checked={selectedApart.length== ownersList.length}
                              onChange={handleSelectAllChange}
                              // defaultChecked
                            />
                          }
                          label="All"
                        />
                      </FormGroup>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <label className="forSelectSocietyLabel myNewLabl">
                      Invoice For
                    </label>
                    <div className="listCheckMain">
                      <FormGroup>
                        {ownersList.map((option, index) => (
                          <p className="checkLineTx" key={option.apartment_id}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  // checked={checkedItems[option.apartment_id] || false}
                                  // onChange={handleChangeSingle(option.apartment_id)}
                                  // defaultChecked

                                  checked={selectedApart.includes(
                                    option.apartment_id
                                  )}
                                  onChange={(e) =>
                                    handleUserCheckboxChange(
                                      option.apartment_id,
                                      option.resident_id,
                                      e.target.checked
                                    )
                                  }
                                />
                              }
                              label={`${option.user_obj.first_name} ${option.user_obj.last_name}`}
                            />{" "}
                            <KeyboardDoubleArrowRightIcon />
                            <span>{option.apt_name}</span>
                          </p>
                        ))}
                        {/* <p className="checkLineTx">
                          <FormControlLabel
                            control={<Checkbox defaultChecked />}
                            label="Check 2"
                          />
                          <span>Wing No: 201 / Flat No: A1</span>
                        </p> */}
                      </FormGroup>
                    </div>
                  </Grid>
                  {/* <Grid item xs={12} md={6}>
                    <label className="tabsLabel">Type</label>
                    <select
                      className="inputSt"
                      value={selectedOption}
                      onChange={handleOptionChange}
                    >
                      <option value="">Select Option</option>
                      <option value="Monthly">Monthly</option>
                      <option value="Quarterly">Quarterly</option>
                      <option value="Annual">Annual</option>
                    </select>
                  </Grid> */}

                  <Grid item xs={12} md={12}>
                    {!flagbtndisable && (
                      <div className="modalMainBtMain">
                        <Button
                          className="modalMainBt"
                          onClick={createInvoices}
                        >
                          Save Invoices
                        </Button>
                      </div>
                    )}
                  </Grid>


                  {/* <Button
                          className="modalMainBt"
                          onClick={testforfirsttime}
                        >
                          first update enddt
                        </Button> */}
                  
                </Grid>
              </div>
            </div>
          </TabPanel>

          {/* for shedule setting added by me */}
          <TabPanel value={value} index={5}>
            <div className="visitorListNewOut">

              <div className="visitorListNewInner">
                <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                <label className="tabsLabel">Type</label>
                <select
                  className="inputSt"
                  value={selectedOption}
                  onChange={handleOptionChange}
                >
                  <option value="">Select Option</option>
                  <option value="Monthly">Monthly</option>
                  <option value="Quarterly">Quarterly</option>
                  <option value="Annual">Annual</option>
                </select>
              </Grid>
                  <Grid item xs={12} md={12}>
                    <div className="modalMainBtMain">
                      <Button className="modalMainBt" onClick={saveScheduler}>
                        Save Scheduler Type
                      </Button>
                      {/* onClick={saveScheduler} */}
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </TabPanel>
          {/*  */}

          <TabPanel value={value} index={6}>
            <div className="visitorListNewOut">
              <div className="visitorListNewInner">
                <Grid container spacing={3}>
                  <Grid item xs={12} md={12}>
                    <div className="modalMainBtMain">
                      <Button className="modalMainBt">Late Fee</Button>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </TabPanel>
        </Box>
      </div>

      {/* <div className="modalMain">
        <Dialog
          open={open}
          onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Add Apartment</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <ServiceProViderAddModal />
            </div>
          </DialogContent>
        </Dialog>
      </div> */}

      {/* Secound Modal */}
      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open2}
          // onClose={handleClose2}
          scroll={scroll2}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Add Vehicle</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose2} />
          </DialogTitle>
          <DialogContent dividers={scroll2 === "paper"}>
            <div className="modalInnerCont">
              <EditMaintenanceModal />
            </div>
          </DialogContent>
        </Dialog>
      </div>

      <div className="modalMain">
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Active the bank Account</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <ActiveBankModal />
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default InvoiceSettingsTab;
